import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { volumes } from '../data/volumes';
export function TomosSection() {
  return <section className="py-24 px-4 bg-carbon" data-id="element-334" data-mp="1kaha0hadz1mn">
      <div className="max-w-6xl mx-auto" data-id="element-335" data-mp="1p4lhr2rh7dos">
        <div className="text-center mb-16" data-id="element-336" data-mp="1p5wkcz96qfeb">
          <p className="text-gold font-bold tracking-widest uppercase mb-3 text-sm" data-id="element-337" data-mp="1u2wrldhrto70">
            6 complete resources in one single package
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-338" data-mp="xeqrn3vsnjz2">
            📚 The <span className="text-gold" data-id="element-339" data-mp="11g29uocc92x8">4-Volume Lesson Library</span>
          </h2>
          <p className="text-xl text-mist" data-id="element-340" data-mp="16brbqybtyvwp">
            100 complete lessons · All levels covered · Nothing to build from scratch
          </p>
          <p className="text-base text-smoke mt-3 max-w-2xl mx-auto" data-id="element-341" data-mp="2hshlgrfgq5v2">
            4 complete lesson volumes + 2 essential teaching tools — all
            structured, all ready, nothing to build from scratch.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-342" data-mp="2qmxi3petauu6">
          {volumes.map((volume, index) => <motion.article key={volume.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className={`bg-carbon-graphite rounded-2xl border ${volume.popular ? 'border-gold' : 'border-carbon-line'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-343" data-mp="2mnygoesahg7h" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-35px] bg-gold text-carbon font-bold text-xs py-1 px-10 rotate-45" data-id="element-344" data-mp="1yxaucohmmo1e">
                  ⭐ MOST POPULAR
                </div>}
              <div className="flex items-center gap-4 mb-6" data-id="element-345" data-mp="1oyd9pwnbneno">
                <span className="text-4xl" aria-hidden="true" data-id="element-346" data-mp="1jza52db97ag8">
                  {volume.icon}
                </span>
                <div data-id="element-347" data-mp="1ab4py7fy6103">
                  <div className="text-gold font-bold text-sm uppercase tracking-wider" data-id="element-348" data-mp="1aauzyjuwjtue">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-white" data-id="element-349" data-mp="11bzuj9zomns5">
                    {volume.title}
                  </h3>
                </div>
              </div>
              <p className="text-white/90 font-medium mb-6 italic border-l-2 border-gold pl-4" data-id="element-350" data-mp="1t2xmgbu864ck">
                {volume.subtitle}
              </p>
              <div className="mb-6" data-id="element-351" data-mp="1y18wonofmgvb">
                <h4 className="text-sm font-bold text-smoke uppercase tracking-wider mb-2" data-id="element-352" data-mp="1kac5n1a5m7qd">
                  What does this solve for your teaching?
                </h4>
                <p className="text-mist text-sm leading-relaxed" data-id="element-353" data-mp="1oa4ihq6kz01j">{volume.problem}</p>
              </div>
              <ul className="space-y-3 mb-8 flex-grow" data-id="element-354" data-mp="2bzf94eu7ve1y">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-355" data-mp="2gu30clglumk8">
                    <CheckIcon size={18} className="text-gold shrink-0 mt-0.5" data-id="element-356" data-mp="5bonggmcb6qg" />
                    <span className="text-mist text-sm" data-id="element-357" data-mp="d532knea307">{bullet}</span>
                  </li>)}
              </ul>
              <div className="border border-gold/40 rounded-xl p-4 mt-auto bg-carbon" data-id="element-358" data-mp="f2awtt3gr10p">
                <span className="text-gold font-bold block mb-1" data-id="element-359" data-mp="a4hrt3dwcd20">Result:</span>
                <p className="text-white text-sm" data-id="element-360" data-mp="3ikufc3wcasib">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}